@if (iconPos === positionEnum.left) {
  @if (icon) {
    <sd-icon [name]="icon" [size]="size" />
  }
  @if (!icon) {
    <sd-icon name="icon-delete" />
  }
}

<ng-content />

@if (iconPos === positionEnum.right) {
  @if (icon) {
    <sd-icon [name]="icon" [size]="size" />
  }
  @if (!icon) {
    <sd-icon name="icon-delete" />
  }
}

@if (buttonIconTitle) {
  <span class="{{titleHidden ? 'is-visually-hidden' : ''}} {{isSmall ? 'is-caption' : ''}}">
    {{buttonIconTitle}}
  </span>
}
